(function (window) {
    var last = +new Date();
    var delay = 100; // default delay

    // Manage event queue
    var stack = [];

    function callback() {
        var now = +new Date();
        if (now - last > delay) {
            for (var i = 0; i < stack.length; i++) {
                stack[i]();
            }
            last = now;
        }
    }

    // Public interface
    var onDomChange = function (fn, newdelay) {
        if (newdelay) delay = newdelay;
        stack.push(fn);
    };

    // Naive approach for compatibility
    function naive() {

        var last = document.getElementsByTagName('*');
        var lastlen = last.length;
        var timer = setTimeout(function check() {

            // get current state of the document
            var current = document.getElementsByTagName('*');
            var len = current.length;

            // if the length is different
            // it's fairly obvious
            if (len != lastlen) {
                // just make sure the loop finishes early
                last = [];
            }

            // go check every element in order
            for (var i = 0; i < len; i++) {
                if (current[i] !== last[i]) {
                    callback();
                    last = current;
                    lastlen = len;
                    break;
                }
            }

            // over, and over, and over again
            setTimeout(check, delay);

        }, delay);
    }

    //
    //  Check for mutation events support
    //

    var support = {};

    var el = document.documentElement;
    var remain = 3;

    // callback for the tests
    function decide() {
        if (support.DOMNodeInserted) {
            window.addEventListener("DOMContentLoaded", function () {
                if (support.DOMSubtreeModified) { // for FF 3+, Chrome
                    el.addEventListener('DOMSubtreeModified', callback, false);
                } else { // for FF 2, Safari, Opera 9.6+
                    el.addEventListener('DOMNodeInserted', callback, false);
                    el.addEventListener('DOMNodeRemoved', callback, false);
                }
            }, false);
        } else if (document.onpropertychange) { // for IE 5.5+
            document.onpropertychange = callback;
        } else { // fallback
            naive();
        }
    }

    // checks a particular event
    function test(event) {
        el.addEventListener(event, function fn() {
            support[event] = true;
            el.removeEventListener(event, fn, false);
            if (--remain === 0) decide();
        }, false);
    }

    // attach test events
    if (window.addEventListener) {
        test('DOMSubtreeModified');
        test('DOMNodeInserted');
        test('DOMNodeRemoved');
    } else {
        decide();
    }

    // do the dummy test
    var dummy = document.createElement("div");
    el.appendChild(dummy);
    el.removeChild(dummy);

    // expose
    window.onDomChange = onDomChange;
})(window);


var limitCheckout = function($){
  
  if (typeof $ == 'undefined') {
    console.warn('jquery is required for the limit checkout feature to work');
    return false;
  }
    
  var lc = {
    conf: {
      checkout_button: $('input[name="checkout"], button[name="checkout"]'),
      multi_checkout_button: $('#gsMultiCheckout'),
      add_on_types: [
        "add-on"
      ],
      alert_message: "Single or Double pint items cannot be shipped alone. You will not be able to check out if they are selected to go to an address without any other items."
    },
    _disableCheckout: function() {
      this.conf.checkout_button.attr('disabled', 'disabled').addClass('disabled');
      this.conf.multi_checkout_button.attr('disabled', 'disabled').addClass('multi_disabled');
      //debugger;
    },
    _enableCheckout: function() {
      this.conf.checkout_button.removeAttr('disabled').removeClass('disabled');
      this.conf.multi_checkout_button.removeAttr('disabled').removeClass('multi_disabled');
      
      //debugger;
    },
    _persistDisabled: function() {
      var attr = this.conf.checkout_button.attr('disabled');

      if (!this.conf.checkout_button.length || this.conf.multi_checkout_button.length > 0) {
        return false;
      }
      
      if (typeof attr !== undefined && attr !== 'disabled') {
        // Element is not disabled - check if it should be
        if (this.conf.checkout_button.hasClass('disabled')) {
          lc._disableCheckout();
        } else {
          lc._enableCheckout();
        }
      }
      
    },
    _persistMultiDisabled: function() {
      
      var multi_attr = this.conf.multi_checkout_button.attr('disabled');

      if (!this.conf.multi_checkout_button.length) {
        return false;
      }
      if (typeof attr !== undefined && attr !== 'disabled') {
        // Element is not disabled - check if it should be
        if (this.conf.multi_checkout_button.hasClass('multi_disabled')) {
          lc._disableCheckout();
        } else {
          lc._enableCheckout();
        }
      } else {
        lc._disableCheckout();
      }
      
    },
    _showAlert: function() {
      alert(lc.conf.alert_message);
    },
    _checkLimit: function() {
      this._getCart
    },
    _getCart: function() {
      
      return new Promise(function(resolve, reject){
        jQuery.getJSON(
          '/cart.js', 
          function(cart) {
          	resolve(cart);
          },
          function(error) {
            console.log(error);
            reject(error);
          }
         )
      });
      
    },
    _getProduct: function() {
      
      return new Promise(function(resolve, reject){
        jQuery.getJSON(
          '/products/red-rain-coat.js', 
          function(product) {
          	resolve(product);
          },
          function(error) {
            reject(error);
          }
         )
      });
      
    },
    _countAddOns: function(cart) {
      
      var add_on_count     = 0;
      var other_item_count = 0;
      var counts = {};
      $.each(cart.items, function(index, item) {
        
        if (item.product_type == "add-on" || item.sku === 'BEST-ENCLOSURE-CARD' || $.inArray(item.product_type, lc.conf.add_on_types) !== -1) {
          add_on_count++; 
        } else {
          other_item_count++;
        }
        
      });
      
      
      counts.add_ons = add_on_count;
      counts.others  = other_item_count;

      
      return counts;
            
      
    },
    _checkEnable: function(counts) {
      if (counts.add_ons > 0 && counts.others === 0) {
        return false;
      } else {
        return true;
        
      }
    },
    _checkCart: function() {
      
      if (!this.conf.checkout_button.length) {
        return false;
      }
      
      this
      ._getCart()
      .then(function(cart){
        var counts = lc._countAddOns(cart);
        var enable = lc._checkEnable(counts);
        
        if (enable === false) {
          lc._disableCheckout();
          lc._showAlert();
        } else {
          lc._enableCheckout();
        }
        
      });
      
    },
    _groupItems: function(cart) {
      
      var groups = [];
      
      $.each(cart.items, function(index, item){
        
        var lp = item.properties || {};
        
        if (!lp.Address) {
          return true;
        }
        
        if (!groups[lp.Address]) {
          groups[lp.Address] = [];
          groups[lp.Address].items = [];
        }
        
        groups[lp.Address].items.push(item);
        
        
      });
      
     
      var indexedArray = [];
      
      for (var i in groups) {
          indexedArray.push(groups[i]);
      }
      
            
      return indexedArray;
    },
    _checkMultiCart: function() {
            
      if (!this.conf.multi_checkout_button.length) {
        return false;
      }
      
      this
      ._getCart()
      .then(function(cart){
        
        var itemGroups      = lc._groupItems(cart);
        var enable_checkout = true;
        
        $.each(itemGroups, function(address, group) {
          
          var counts = lc._countAddOns(group);
          var enable = lc._checkEnable(counts);
          if (enable === false) {
            enable_checkout = false;
          }
          
        });
        if (enable_checkout === false) {
          lc._disableCheckout();
          lc._showAlert();
        } else {
          lc._enableCheckout();
        }    
        
        
      });
      
      
    },
    events:function() {
      
      window.onDomChange(function(){
        if (lc.conf.checkout_button.length > 0) {
        	lc._persistDisabled();
        }
        
        if (lc.conf.multi_checkout_button.length > 0) {
          lc._persistMultiDisabled();
        }
      });

    },
    init: function() {
      
      this.events();
      this._disableCheckout();
      this._checkCart();
      this._checkMultiCart();
    },
    
  
  };
  
  lc.init();
      
  
  
};

var GsLoaded = function() {
  
  limitCheckout(jQuery);
  
  
  Gs.$("#gsAppContainer").css("display", "none");
    
  Gs.$(document).on('click', '[href="/a/gs/cart/"]', function() {
      
      Gs.$(this).css({
        'background-color': '#004750',
        'color': '#fff'
      });
    
  });
  
};